// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import toast from 'react-hot-toast';

const LoginPage = () => {
  const navigate = useNavigate();
  const { signIn, signInWithGoogle } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success('Welcome back!');
      navigate('/');
    } catch {
      toast.error('Incorrect email or password');
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    try {
      await signInWithGoogle();
      navigate('/');
    } catch {
      toast.error('Google sign in failed. Please try again.');
    }
  };

  return (
    <div style={s.page}>
      {/* Logo */}
      <div style={s.logo}>
        <div style={s.logoMark}>
          <div style={s.logoCircle} />
          <span style={s.logoWord}>Gather</span>
        </div>
      </div>

      <h1 style={s.h1}>Welcome back</h1>
      <div style={s.sub}>Sign in to your Gather account</div>

      {/* Google */}
      <button style={s.googleBtn} onClick={handleGoogle}>
        <span>🔵</span> Continue with Google
      </button>

      <div style={s.orDivider}><span>or</span></div>

      {/* Email form */}
      <form style={s.form} onSubmit={handleEmail}>
        <label className="form-group">
          <span style={s.label}>Email</span>
          <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required />
        </label>
        <label className="form-group">
          <span style={s.label}>Password</span>
          <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
        </label>
        <button type="submit" style={{ ...s.submitBtn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>

      <div style={s.footer}>
        Don't have an account?{' '}
        <Link to="/signup" style={s.link}>Create one free</Link>
      </div>
      <div style={s.footer}>
        <Link to="/" style={s.link}>Continue without signing in →</Link>
      </div>
    </div>
  );
};

const s = {
  page: {
    minHeight: '100vh', background: 'var(--cream)',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', padding: '60px 24px 40px',
  },
  logo: { marginBottom: 32 },
  logoMark: {
    width: 120, height: 120, background: 'var(--sage)',
    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    position: 'relative',
  },
  logoCircle: { position: 'absolute', inset: 8, borderRadius: '50%', border: '1.5px solid rgba(255,255,255,0.35)' },
  logoWord: { fontFamily: 'Nunito, sans-serif', fontSize: 24, fontWeight: 400, color: 'var(--sage-dark)' },
  h1: { fontSize: 26, fontWeight: 800, color: 'var(--ink)', marginBottom: 6, letterSpacing: '-0.3px' },
  sub: { fontSize: 14, color: 'var(--muted)', fontWeight: 500, marginBottom: 28 },
  googleBtn: {
    width: '100%', background: 'var(--white)', border: '1.5px solid var(--border)',
    borderRadius: 14, padding: 15,
    fontSize: 15, fontWeight: 700, fontFamily: 'Nunito, sans-serif',
    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
    marginBottom: 20,
  },
  orDivider: {
    width: '100%', textAlign: 'center', position: 'relative', marginBottom: 20,
    fontSize: 13, color: 'var(--muted)', fontWeight: 600,
  },
  form: { width: '100%', display: 'flex', flexDirection: 'column', gap: 14 },
  label: { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.2px', color: 'var(--muted)' },
  submitBtn: {
    width: '100%', background: 'var(--sage-deep)', color: 'white',
    border: 'none', borderRadius: 16, padding: 17,
    fontSize: 16, fontWeight: 700, fontFamily: 'Nunito, sans-serif', cursor: 'pointer',
    marginTop: 4,
  },
  footer: { marginTop: 20, fontSize: 14, color: 'var(--muted)', fontWeight: 500, textAlign: 'center' },
  link: { color: 'var(--sage-deep)', fontWeight: 700 },
};

export default LoginPage;
